import { useState, type FormEvent } from 'react';
import { workflow } from '../../api/endpoints';
import type { Comment } from '../../api/types';
import { useAsync } from '../../hooks';
import { Card, Column, DataTable, ErrorBox, Field, fmtDate, label } from '../../components/ui';
import type { CardData } from '../RequestCardPage';

export function CommentsTab({ data }: { data: CardData }) {
  const comments = useAsync<Comment[]>(() => workflow.comments(data.request.id), [data.request.id]);
  const [body, setBody] = useState('');
  const [visibility, setVisibility] = useState('internal');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<unknown>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await workflow.addComment(data.request.id, body, visibility);
      setBody('');
      comments.reload();
    } catch (x) { setErr(x); } finally { setBusy(false); }
  };

  const cols: Column<Comment>[] = [
    { key: 'created_at', title: 'Время', render: (r) => fmtDate(r.created_at), width: '150px' },
    { key: 'author', title: 'Автор', render: (r) => (r.author != null ? String(r.author) : '—'), width: '120px' },
    { key: 'body', title: 'Текст', render: (r) => r.body },
    { key: 'visibility', title: 'Видимость', render: (r) => label(r.visibility), width: '110px' },
  ];

  return (
    <Card title="Обсуждение по заявке">
      <ErrorBox error={comments.error} onRetry={comments.reload} />
      <DataTable columns={cols} rows={comments.data ?? []} empty="Комментариев нет" />
      <form className="inline-form" onSubmit={submit}>
        <ErrorBox error={err} />
        <Field label="Новый комментарий">
          <textarea value={body} onChange={(e) => setBody(e.target.value)} required
                    placeholder="Текст комментария…" />
        </Field>
        <div className="form-row">
          <Field label="Видимость">
            <select value={visibility} onChange={(e) => setVisibility(e.target.value)}>
              <option value="internal">Внутренний</option>
              <option value="client">Клиентский</option>
              <option value="all">Все</option>
            </select>
          </Field>
        </div>
        <div className="form-actions">
          <button className="btn primary" disabled={busy || !body.trim()}>{busy ? 'Отправка…' : 'Добавить комментарий'}</button>
        </div>
      </form>
    </Card>
  );
}
